export const url = "https://djangoapi.augusto.digital/"
